export { default } from "./confirmDetails";
